import { ExtendedAxiosResponse, apiClient } from 'helpers/apiClient';

export const api = {
  getData: (url: string, invoicenumber: string, serviceno: string, serviceid: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/summary/getData`, {
      params: {
        invoicenumber,
        serviceno,
        serviceid,
      },
    }),
};
